import { createI18n, LANG_LOCALE, type Lang, type Vars } from '@bak/admin-ui'

import { en, id, type MessageKey } from './messages/index.js'

export type { Lang, MessageKey, Vars }
export { LANG_LOCALE }
export type T = (key: MessageKey, vars?: Vars) => string

export const { I18nProvider, useT, useLang, translate, getLang } = createI18n<MessageKey>({ en, id }, { storageKey: 'bak-console-lang' })
